import { type ReactNode } from "react"
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { FloatingCard } from "@/components/FloatingCard"
import { type LucideIcon } from "lucide-react"

// Stat tile with optional click-to-filter behavior (ring + aria-pressed when active).
// Extracted from IndustryNews (slice 3) for reuse by the Repurposing page (slice 4).
export function StatCard({
  title,
  value,
  hint,
  icon: Icon,
  testId,
  active,
  onClick,
}: {
  title: string
  value: ReactNode
  hint: string
  icon: LucideIcon
  testId: string
  active?: boolean
  onClick?: () => void
}) {
  const card = (
    <FloatingCard clickable={!!onClick} className={active ? "ring-2 ring-primary" : ""}>
      <CardHeader className="flex flex-row items-center justify-between gap-2 space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        <Icon className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold" data-testid={testId}>{value}</div>
        <p className="text-xs text-muted-foreground">{hint}</p>
      </CardContent>
    </FloatingCard>
  )
  if (!onClick) return card
  return (
    <div
      role="button"
      tabIndex={0}
      aria-pressed={active}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault()
          onClick()
        }
      }}
      className="rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      {card}
    </div>
  )
}
